// src/js/components/Evaluation/Results.js
import React, { Component } from "react";
import { connect } from "react-redux";
// import renderHTML from "react-render-html";

import './Results.css';
import ModuleResults from "./ModuleResults";

const mapStateToProps = state => {
    return {
        displayresults: state.displayresults,
        modules: state.data.questionnaire.modules,
        results: state.results,
        formsent: state.formsent,
        outputresults: state.outputresults,
        benchmark: state.data.benchmark.modules
    };
};

function mapDispatchToProps(dispatch) {
    return {};
}

class ConnectedResults extends Component {
    constructor(props){
        super(props);

        this.scrollToDownloadForm = this.scrollToDownloadForm.bind(this);
    }

    scrollToDownloadForm() {
        let el = document.getElementById('actionplan');
        if(el !== undefined) {
            setTimeout(() =>
                    el.scrollIntoView({behavior: "smooth", block: "start", inline: "start"})
                , 50
            );
        } else {
            console.log('error: download form cannot be found');
        }
    }

    render() {
        if(this.props.displayresults) {
            return (
                <div className="evModuleContainer" id="qresults">
                    <div className="evModuleTitleContainer">
                        <div className="evModuleTitle">
                            Review your results
                        </div>
                        <div className="evModuleClear"></div>
                    </div>
                    <div className="evResultsContainer">
                        <div>
                            <div className="evThankyouMessage">
                                <p>Thank you for completing our trial Board evaluation. Now for your results.</p>
                                <p>Below your responses are compared to our 2020 benchmark data for our Risk Management and Compliance and Stakeholder Engagement modules.</p>
                            </div>
                            <div className="evThankyouButton">
                                <BookButton onclick={this.scrollToDownloadForm} formsent={this.props.formsent} />
                            </div>
                            <div className="evModuleClear"></div>
                        </div>
                        <div className="evResultsInnerContainer">
                            {this.props.outputresults.map((module, index) => <ModuleResults key={index} module={module} index={index} />) }
                        </div>
                        {/*<div>*/}
                        {/*    <div className="evThankyouMessage">*/}
                        {/*        <h2>What can I do with my results?</h2>*/}
                        {/*        <p>Governance Evaluator offers a number of services in relation to reviewing and discussing results prior to planning your actions in step three. Options available include:</p>*/}
                        {/*        <ol className={'evShowBulletsNum'}>*/}
                        {/*            <li>Governance data insight result reports (inclusive of benchmarking) for discussion at board meetings. </li>*/}
                        {/*            <li>*/}
                        {/*                <p>Independently lead, sector expert, convening options</p>*/}
                        {/*                <div>*/}
                        {/*                    <div className='evalListSplit'>*/}
                        {/*                        <ul className={'evShowBulletsDot'}>*/}
                        {/*                            <li>Confidential Director interviews</li>*/}
                        {/*                            <li>Desktop reviews</li>*/}
                        {/*                            <li>Peer Reviews</li>*/}
                        {/*                            <li>Board Committee reviews</li>*/}
                        {/*                        </ul>*/}
                        {/*                    </div>*/}
                        {/*                    <div>*/}
                        {/*                        <ul className={'evShowBulletsDot'}>*/}
                        {/*                            <li>Recommendation reports</li>*/}
                        {/*                            <li>Facilitated Planning sessions</li>*/}
                        {/*                            <li>Action Plans linked to support resources and expert sector services.</li>*/}
                        {/*                        </ul>*/}
                        {/*                    </div>*/}
                        {/*                    <div className='evModuleClear'></div>*/}
                        {/*                </div>*/}
                        {/*            </li>*/}
                        {/*        </ol>*/}
                        {/*        <p>Next, step three, plan to act!</p>*/}
                        {/*    </div>*/}
                        {/*    <div className="evThankyouButton">*/}
                        {/*        <BookButton onclick={this.scrollToDownloadForm} formsent={this.props.formsent} />*/}
                        {/*    </div>*/}
                        {/*    <div className='evModuleClear'></div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
}
const Results = connect(mapStateToProps,mapDispatchToProps)(ConnectedResults);

export default Results;

function BookButton(props) {
    if (!props.formsent)
        return <div className="evBookButton" onClick={props.onclick}>Plan to act! &gt;</div>
    else
        return null
}